import { useEffect, useState } from "react";
import "./MobileLogin.css";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { message } from "antd";
import SideMenu from "../../components/Header/SideMenu";
import HeroSvg from "../../components/Layout/HeroSvg";
import { setActiveButton } from "../../redux/features/footerMenuSlice";
import {
	ChevronLeftSvg,
	CallSvg,
	ListSvg,
	AsteriskSvg,
	EmailSvg,
	PersonSvg,
	PasswordSvg,
} from "../../components/AllSvgModulesExport/LoginSvg";
import { v4 as uuidv4 } from "uuid";
import CryptoJS from "crypto-js";
import { apiClient } from "../../config/api.client";
import { userExist } from "../../redux/features/userSlice";
import { sendOtp, verifyOtp, completeRegistration } from "../../services/user.service";
import MarketingConsentCheckbox from "../../components/MarketingConsent/MarketingConsentCheckbox";
import TermsConsentCheckbox from "../../components/MarketingConsent/TermsConsentCheckbox";

const MobileLogin = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [sideMenu, setSideMenu] = useState(false);
	const [form, setForm] = useState({});
	const [isChecked, setisChecked] = useState(false);
	const [loading, setLoading] = useState(false);
	const [showPassword, setShowPassword] = useState(false); // State to manage password visibility
	const [errors, setErrors] = useState({
		mobile: false,
		isChecked: false,
		referralSource: false,
	});
	const [tab, setTab] = useState(0);
	const [ip, setIp] = useState("");
	const allowedReferralSources = ["Google","Facebook","Instagram","YouTube","Friend","Other"];
	const [mobileValidation, setMobileValidation] = useState({
		isValid: null, // null = no validation, true = valid, false = invalid
		message: ""
	});

	const handleChange = (e) => {
		const { name, value } = e.target;
		
		// For mobile number, only allow digits and limit to 10 characters
		if (name === 'mobile') {
			const numericValue = value.replace(/\D/g, ''); // Remove non-digits
			if (numericValue.length <= 10) {
				setForm((prevForm) => ({ ...prevForm, [name]: numericValue }));
				
				// Real-time validation feedback
				const indianMobileRegex = /^[6-9]\d{9}$/;
				
				if (numericValue.length === 0) {
					setMobileValidation({ isValid: null, message: "" });
				} else if (numericValue.length < 10) {
					// Check if it starts with valid Indian prefix
					if (/^[6-9]/.test(numericValue)) {
						setMobileValidation({ 
							isValid: true, 
							message: "Complete 10 digit mobile number" 
						});
					} else {
						setMobileValidation({ 
							isValid: false, 
							message: "Invalid number, only Indian number supports" 
						});
					}
				} else if (numericValue.length === 10) {
					if (indianMobileRegex.test(numericValue)) {
						setMobileValidation({ 
							isValid: true, 
							message: "Valid Indian mobile number" 
						});
					} else {
						setMobileValidation({ 
							isValid: false, 
							message: "Invalid Indian mobile number format" 
						});
					}
				}
			}
		} else {
			setForm((prevForm) => ({ ...prevForm, [name]: value }));
		}
		setErrors((prevErrors) => ({ ...prevErrors, [name]: false }));
	};

	const handleConditionChecked = (e) => {
		setisChecked(e.target.checked);
		setErrors((prevErrors) => ({ ...prevErrors, isChecked: false }));
	};

	// Generate or retrieve the device ID
	const getDeviceId = () => {
		let deviceId = localStorage.getItem("deviceId");
		if (!deviceId) {
			deviceId = uuidv4(); // Generate a new UUID
			localStorage.setItem("deviceId", deviceId);
		}
		setForm((prevForm) => ({ ...prevForm, deviceId: deviceId }));
	};

	const fetchIp = async () => {
		try {
			const response = await apiClient.get("https://api.ipify.org?format=json");
			setIp(response.data.ip);
			setForm((prevForm) => ({ ...prevForm, ip: response.data.ip }));
		} catch (error) {
			console.error("Error fetching IP address:", error);
		}
	};

	useEffect(() => {
		fetchIp();
		getDeviceId();
	}, []);

	const sendMobileOtp = async (e) => {
		e.preventDefault();
		if (form?.mobile?.length !== 10) {
			return message.error("Enter 10 digits mobile number");
		}

		// Indian mobile number validation
		const indianMobileRegex = /^[6-9]\d{9}$/;
		if (!indianMobileRegex.test(form?.mobile)) {
			return message.error("Please enter a valid Indian mobile number (starting with 6, 7, 8, or 9)");
		}

		if (!isChecked) {
			return message.error("Please check the box");
		}

		try {
			setLoading(true);
			const res = await sendOtp(form.mobile);
			if (res?.success !== false) {
				setTab(1);
				setLoading(false);
			} else {
				message.error(res?.message || "Failed to send OTP");
				setLoading(false);
			}
		} catch (error) {
			setLoading(false);
			// Handle API error responses properly
			if (error.response && error.response.data && error.response.data.message) {
				message.error(error.response.data.message);
			} else if (error.message) {
				message.error(error.message);
			} else {
				message.error("Something went wrong");
			}
			console.log(error);
		}
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		
		// Indian mobile number validation
		const indianMobileRegex = /^[6-9]\d{9}$/;
		if (!indianMobileRegex.test(form?.mobile)) {
			return message.error("Please enter a valid Indian mobile number (starting with 6, 7, 8, or 9)");
		}

		if (!form?.otp) {
			return message.error("Please enter 6 digits OTP");
		}
		if (form?.otp?.length !== 6) {
			return message.error("Enter 6 digits OTP");
		}

		try {
			const data = await verifyOtp(form.mobile, form.otp);
			if (data) {
				if (data.isNewUser || data.requiresRegistration) {
					if (data.phone) {
						setForm((prev) => ({ ...prev, mobile: data.phone }));
					}
					if (data.registrationToken) {
						setForm((prev) => ({ ...prev, registrationToken: data.registrationToken }));
					}
					setTab(2);
				} else {
					localStorage.setItem("token", data.token);
					dispatch(userExist(data.user));
					navigate("/");
				}
			} else {
				message.error(data?.message || "Verification failed");
			}
		} catch (error) {
			// Handle API error responses properly
			if (error.response && error.response.data && error.response.data.message) {
				message.error(error.response.data.message);
			} else if (error.message) {
				message.error(error.message);
			} else {
				message.error("Something went wrong");
			}
			console.log(error);
		}
	};

	const handleProfieUpdate = async (e) => {
		e.preventDefault();
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		
		// Indian mobile number validation
		const indianMobileRegex = /^[6-9]\d{9}$/;
		if (!indianMobileRegex.test(form?.mobile)) {
			return message.error("Please enter a valid Indian mobile number (starting with 6, 7, 8, or 9)");
		}
		
		// Check for empty fields first
		if (!form?.email || form?.email === "" || !form?.fname || form?.fname === "" || !form?.password || form?.password === "" || !form?.referralSource || form?.referralSource === "") {
			return message.error(
				`Please Enter ${!form?.fname || form?.fname === "" ? "your name" : !form?.email || form?.email === "" ? "your email" : !form?.password || form?.password === "" ? "a password" : "how you heard about us"}`
			);
		}
		
		// Email validation
		if (!emailRegex.test(form?.email)) {
			return message.error("Please enter a valid email address");
		}
		
		// Name length validation
		if (form?.fname?.length < 3) {
			return message.error("Name should be at least 3 characters");
		}
		
		// Password length validation
		if (form?.password?.length < 5) {
			return message.error("Password should be at least 5 characters");
		}
		
		if (!form?.termsAccepted) {
			return message.error("Please accept the Terms & Conditions and Privacy Policy");
		}

		setLoading(true);
		try {
			const data = await completeRegistration(form.mobile, form.fname, form.email, form.password, form?.referralSource, form?.registrationToken, !!form?.marketingConsent);
			if (data) {
				localStorage.setItem("token", data.token);
				message.success(data.message);
				dispatch(userExist(data.user));
				navigate("/");
			} else {
				message.error(data.message);
			}
		} catch (error) {
			// Handle backend validation errors
			if (error.response && error.response.data && error.response.data.message) {
				message.error(error.response.data.message);
			} else {
				message.error("Something went wrong");
			}
		} finally {
			setLoading(false);
		}
	};

	const onClose = () => {
		dispatch(setActiveButton("home"));
		localStorage.setItem("activeButton", "home");
		navigate("/");
	};

	return (
		<>
			<div className={`account-modal-container d-lg-none d-md-none `}>
				<HeroSvg />
				<div className="account-modal-container-content">
					<div className="top-left-content">
						<div className="box-1 center" onClick={onClose}>
							<ChevronLeftSvg />
						</div>
						<h2 className="mb-0">Login</h2>
					</div>
					<div
						className="top-right-content box-2 center"
						onClick={() => setSideMenu(!sideMenu)}
					>
						<ListSvg />
					</div>
				</div>
				{tab === 0 && (
					<div className="mobile-login-container px-3 mt-3">
						<div className="mobile-login-content px-4 py-3">
							<form className="content" autoComplete="off">
								<h1 className="mb-0 pt-2">Welcome back !!</h1>
								<p>Fill up the form</p>
								<div className="form-custom form-label form-border form-icon mb-3 bg-transparent">
									<div className="form-input position-relative">
										<input
											type="tel"
											autoComplete="off"
											name="mobile"
											placeholder="Your number"
											id="mobile"
											className={`form-control text-muted rounded-xs ${
												mobileValidation.isValid === true && form?.mobile?.length === 10 ? 'is-valid' : 
												mobileValidation.isValid === true && form?.mobile?.length < 10 ? 'border-warning' :
												mobileValidation.isValid === false ? 'is-invalid' : ''
											}`}
											value={form.mobile}
											onChange={handleChange}
											maxLength={10}
											pattern="[0-9]{10}"
											title="Please enter a 10-digit mobile number"
										/>
										{mobileValidation.message ? (
											<div
											 className={`${
												mobileValidation.isValid === true && form?.mobile?.length === 10 ? 'valid-feedback' : 
												mobileValidation.isValid === true && form?.mobile?.length < 10 ? 'text-warning' :
												'invalid-feedback'
											} d-block`}
											style={{fontSize: '12px', marginTop: '4px'}}
											>
												{mobileValidation.message}
											</div>
										) : (
											<div className="invalid-feedback">
												Please enter your mobile number
											</div>
										)}
										<CallSvg />
									</div>
								</div>

								<div className="form-check form-check-custom">
									<input
										className={`form-check-input ${isChecked && "bg-success"}`}
										type="checkbox"
										id="c22"
										checked={isChecked}
										onChange={handleConditionChecked}
									/>
									<label className="form-check-label" htmlFor="c22">
										<small>
											I agree to all{" "}
											<Link to="/terms-and-conditions">
												terms &amp; conditions
											</Link>
										</small>
									</label>
									{errors.isChecked && (
										<div className="invalid-feedback d-block">
											You must agree to the terms &amp; conditions
										</div>
									)}
								</div>
								<button
									onClick={sendMobileOtp}
									className="mobile-login-button mt-3"
									type="submit"
								>
									{loading ? (
										<div
											className="spinner-border spinner-border-sm"
											role="status"
										>
											<span className="visually-hidden"></span>
										</div>
									) : (
										"LOGIN"
									)}
								</button>
							</form>
						</div>
					</div>
				)}

				{/* VERIFICATION */}
				{tab === 1 && (
					<div className="mobile-login-container px-3 mt-3">
						<div className="mobile-login-content px-4 py-3">
							<form className="content" autoComplete="off">
								<h1 className="mb-0 pt-2">OTP verification</h1>
								<p>Enter OTP</p>
								<div className="form-custom form-label form-border form-icon mb-3 bg-transparent">
									<div className="form-input">
										<input
											type="number"
											autoComplete="off"
											name="otp"
											placeholder="Enter otp"
											id="otp"
											className={`form-control text-muted rounded-xs ${errors.otp && "is-invalid"
												}`}
											value={form?.otp}
											onChange={handleChange}
										/>
										<AsteriskSvg />
									</div>
								</div>

								<button
									onClick={handleSubmit}
									className="mobile-login-button mt-3"
									type="submit"
								>
									{loading ? (
										<div
											className="spinner-border spinner-border-sm"
											role="status"
										>
											<span className="visually-hidden"></span>
										</div>
									) : (
										"VERIFY"
									)}
								</button>
							</form>
						</div>
					</div>
				)}

				{tab === 2 && (
					<div className="mobile-login-container px-3 mt-3">
						<div className="mobile-login-content px-4 py-3">
							<form className="content" autoComplete="off">
								<h1 className="mb-0 pt-2">Profile Update</h1>
								<p>Fill up the form</p>
								<div className="form-custom form-label form-border form-icon mb-3 bg-transparent">
									<div className="form-input">
										<input
											type="text"
											autoComplete="off"
											name="fname"
											placeholder="Your full name"
											id="email"
											className={`form-control text-muted rounded-xs ${errors.email && "is-invalid"
												}`}
											value={form.fname}
											onChange={handleChange}
										/>
										<div className="invalid-feedback">Please enter name</div>
										<PersonSvg />
									</div>
								</div>
								<div className="form-custom form-label form-border form-icon mb-3 bg-transparent">
									<div className="form-input">
										<input
											type="email"
											autoComplete="off"
											name="email"
											placeholder="Your email"
											id="email"
											className={`form-control text-muted rounded-xs ${errors.email && "is-invalid"
												}`}
											value={form.email}
											onChange={handleChange}
										/>
										<div className="invalid-feedback">
											Please enter your email
										</div>
										<EmailSvg />
									</div>
								</div>
								<div className="form-custom form-label form-border form-icon mb-3 bg-transparent">
									<div className="form-input">
										<input
											type="password"
											autoComplete="off"
											name="password"
											placeholder="Your password (min 5 characters)"
											style={{fontSize:'14px'}}
											id="password"
											className={`form-control text-muted rounded-xs ${errors.password && "is-invalid"
												}`}
											value={form.password}
											onChange={handleChange}
											minLength={5}
										/>
										<div className="invalid-feedback">
											Please enter your password
										</div>
										<PasswordSvg />
									</div>
								</div>
								<div className="form-custom form-label form-border form-icon mb-3 bg-transparent">
									<div className="form-input">
										<select
											name="referralSource"
											className={`form-control text-muted rounded-xs ${errors.referralSource && "is-invalid"}`}
											value={form?.referralSource || ""}
											onChange={handleChange}
											required
										>
											<option value="" disabled>
												How did you hear about us? *
											</option>
											{allowedReferralSources.map((source) => (
												<option key={source} value={source}>
													{source}
												</option>
											))}
										</select>
										<div className="invalid-feedback">
											Please select how you heard about us
										</div>
									</div>
								</div>
								<div className="mb-3">
									<MarketingConsentCheckbox
										checked={form?.marketingConsent}
										onChange={(checked) => setForm((prev) => ({ ...prev, marketingConsent: checked }))}
									/>
									<TermsConsentCheckbox
										className="mt-2"
										checked={form?.termsAccepted}
										onChange={(checked) => setForm((prev) => ({ ...prev, termsAccepted: checked }))}
									/>
								</div>

								<button
									onClick={handleProfieUpdate}
									className="mobile-login-button mt-3"
									type="submit"
								>
									{loading ? (
										<div
											className="spinner-border spinner-border-sm"
											role="status"
										>
											<span className="visually-hidden"></span>
										</div>
									) : (
										"UPDATE"
									)}
								</button>
							</form>
						</div>
					</div>
				)}
			</div>

			<SideMenu sideMenu={sideMenu} setSideMenu={setSideMenu} />
		</>
	);
};

export default MobileLogin;
